import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { ToastrService } from 'ngx-toastr';
import { Contact } from 'src/app/shared/models/clients/contact';
import { ContactModalComponent } from '../contact-modal/contact-modal.component';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { PrintService } from 'src/app/core/services/print.service';

@Component({
  selector: 'app-client-contact',
  templateUrl: './client-contact.component.html',
  styleUrls: ['./client-contact.component.scss']
})
export class ClientContactComponent implements OnInit {
  public contacts: Contact[] = [];
  public clientId = null;
  public searchParams = new SearchParams();
  @ViewChild('contactModal') contactModal: ContactModalComponent;

  constructor(
    private apiService: ClientsApiService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private printService: PrintService,
  ) {
    this.route.parent.data.subscribe(resolversData => {
      this.clientId = resolversData.client.id;
    });
  }

  ngOnInit(): void {
    this.loadContacts();
  }

  loadContacts() {
    this.spinner.show();
    this.apiService.getClientContacts(this.searchParams, this.clientId).subscribe(
      c => {
        this.spinner.hide();
        this.contacts = c.results;
      }
    )
  }

  onSearch(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.searchParams.page = 1;
      this.searchParams.search = (e.target as HTMLInputElement).value;
      this.loadContacts();
    }
  }

  addnewContact() {
    const contact = new Contact();
    contact.clientId = this.clientId;
    this.contactModal.open(contact);
  }

  editContact(contact: Contact) {
    this.contactModal.open(contact);
  }

  contactSubmit(contact: Contact) {
    let action = '';
    if (this.contacts.find(n => contact.id === n.id)) {
      const i = this.contacts.findIndex((value, index, arr) => value.id === contact.id);
      this.contacts[i] = contact;
      action = 'updated';
    } else {
      this.contacts.push(contact);
      action = 'created';
    }
    this.contactModal.close();
    this.toastr.success(`Client ${action}`, 'Success!');
  }

  print() {
    this.route.parent.data.subscribe(resolversData => {
      this.printService.data = { contacts: this.contacts, clientName: resolversData.client.fullName };
      this.printService.printDocument('client-contacts');
    });
  }
}
